import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isLoading : false,

    miniSidenav: false,
    darkSidenav: false,
    sidenavColor: null,
    transparentNavbar: true,
    fixedNavbar: true,
    openConfigurator: false,
    direction: "rtl",
    layout: "dashboard",
    darkMode: false,
}

export const pageSlice = createSlice({
    name: 'page',
    initialState,
    reducers: {
      setPageLoading: (state, action) => {
        state.isLoading = true;
        
      },
      setPageLoadFinish: (state, action) => {
        state.isLoading = false;
        
      },
     setMiniSidenav : (state, { payload }) => { 
      state.miniSidenav = payload;
     },
     setDarkSidenav : (state, { payload }) => { 
      state.darkSidenav = payload;
     },
     setSidenavColor : (state, { payload }) => {
      state.sidenavColor = payload;
      },
     setTransparentNavbar  : (state, { payload }) => { 
      state.transparentNavbar = payload;
     },
     setFixedNavbar  : (state, { payload }) => {
      state.fixedNavbar = payload;
      },
     setOpenConfigurator  : (state, { payload }) => { 
      state.openConfigurator = payload;
     },
     setDirection  : (state, { payload }) => {
      state.direction = payload;
      },
     setLayout  : (state, { payload }) => {
      state.layout = payload;
      },
     setDarkMode  : (state, { payload }) => { 
      state.darkMode = payload;
     }
    }
  });

export const { setPageLoading, setPageLoadFinish,
  
  setMiniSidenav,setDarkSidenav,
  setSidenavColor,setTransparentNavbar,setFixedNavbar,setLayout,setDarkMode,setDirection,setOpenConfigurator
} = pageSlice.actions;

export default pageSlice.reducer;